export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: 'linear-gradient(135deg, rgba(225, 138, 129, 0.2) 0%, rgba(242, 242, 233, 0.4) 50%, rgba(225, 138, 129, 0.2) 100%)',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#275067',
    contrastText: '#FFFFFF',
    light: '#e9ebf1',
  },
  secondary: {
    main: '#E18A81',
    contrastText: '#668E4D',
  },
  text: {
    primary: '#141B22',
    primaryLight: '#80A868',
    secondary: '#697883',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    muted: '#4A5462',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#FFF4E8',
    paper: '#FFF',
    default: '#FFF',
    footer: '#F2F6F9',
    level2: '#FBFAFA',
    level1: '#FFF',
    header: '#041E42',
    tableHead: '#285068',
    tableSubhead: 'rgba(242, 246, 249, 1)',
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
    secondary: '#F8F4F2',
    subscription: '#285068',
  },
  surface: {
    grey: '#F2F2F2',
  },
  verticalBar: {
    used: '#7BD6D0',
    unused: '#e9ebf1',
    unlimited: '#C0C0C0',
  },
};
